import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { RichTextParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Article (HTML) Card", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  richText: RichTextParticleSpec.generateSchema("Rich Text Area", "The rich text area."),
}));
